<!-- 这是临床科室分类页面 -->
<template>
  <div class='clinicDeptType'>
    <div class="header df-between" id='header' :style="{'padding-top':utils.isIphoneX()?'50px':'30px'}">
      <img src="../../assets/images/i-arrow-left.png" @click='handleBack' alt="" >
      <div class="title">{{pageTitle}}</div>
      <span class='add' @click='handleAdd' >添加</span>
    </div>
    <div class="search-box" id='searchBox' :style="{'top':headerHeight+'px'}">
      <img src="../../assets/images/iv_search.png" alt="" >
      <input type="text" v-model='searchName' @blur='handleChange' @input='handleChange' placeholder="输入关键字搜索">
    </div>
    <div class="container" :style="{'padding-top':searchBoxHeight+'px','height':containerHeight}">
      <div class="item">
        <div class="item-title df-item-center">
          自定义临床科室分类
        </div>
        <div class="item-content-box">
          <div class="item-content df-item-center" @click='conFirmClinicDeptType(d)' v-for='(d,idx) in this.notRelatedList' :key='idx'>
            {{d.name}}
          </div>
        </div>
        <div class="item-title df-item-center">
          默认临床科室分类
        </div>
        <div class="item-content-box">
          <div class="item-content df-item-center" @click='conFirmClinicDeptType(d)' v-for='(d,idx) in this.templateList' :key='idx'>
            {{d.name}}
          </div>
        </div>
      </div>
      <div class="mask" v-if='isShowPopup'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title">自定义临床科室分类</div>
            <div class="box">

              <div class="box-item df-between">
                <div class="ittm-left df-center">
                  临床科室分类名称
                  <span style='color:red;'>*</span>
                </div>
                <div class="item-right">
                  <input type="text" v-model="deptName" placeholder="请输入">
                </div>
              </div>
              <div class="box-item df-between" @click='handleShowQuickTag'>
                <div class="ittm-left df-center">
                  请选择快速搜索标签
                  <span style='color:red;'>*</span>
                </div>
                <div class="item-right">
                  <input type="text" v-model="parentDeptName" placeholder="请选择">
                  <img src="../../assets/images/arrow-bottom.png" v-if='!isShowQuickTag' alt="">
                  <img src="../../assets/images/arrow-top.png" alt="" v-else>
                  <ul v-if='isShowQuickTag'>
                    <li class='df-item-center' @click='handleConfirmQuickTag(item)' v-for='(item,index) in quickTagData' :key='index'>{{item.name}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="btn-box df-between">
            <div class="btn btn-gray df-center" @click='handleBtnLeft' >取消</div>
            <div class="btn df-center" @click='handleBtnRight' >确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

  export default {
    props:['clinicDeptTypeData','quickTagData'],
    data() {
      return {
        notRelatedList:[],
        templateList:[],
        headerHeight:'',
        searchBoxHeight:'',
        containerHeight:'',
        searchName:'',
        isShowQuickTag:false,
        deptName:'',
        parentDeptName:'',
        parentId:'',
        parentDeptCode:'',
        templateType:'',
        pageTitle:'临床科室分类',
        isShowPopup:false,
      }
    },
    computed: {
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
      })
    },
    created() {
      setTimeout(()=>{
        console.log(this.clinicDeptTypeData,'clinicDeptTypeData');
      })
    },
    mounted(){
      this.headerHeight = document.getElementById('header').offsetHeight
      this.searchBoxHeight = document.getElementById('searchBox').offsetHeight
      this.containerHeight = `calc(100% - ${parseInt(this.headerHeight)}px)`
      console.log(this.containerHeight,'this.containerHeight');
    },
    watch:{
      clinicDeptTypeData(){
        this.notRelatedList = this.clinicDeptTypeData.notRelatedList
        this.templateList = this.clinicDeptTypeData.templateList
      }
    },
    methods: {
      // 搜索
      handleChange(){
        let data1 = []
        let data2 = []
        if(this.searchName){
          this.clinicDeptTypeData.notRelatedList.forEach((v,i)=>{
            let str = this.searchName
            let reg = new RegExp(str,'g')
            if(reg.test(v.name)){
              data1.push(v)
            }
          })
          this.notRelatedList = data1
          this.clinicDeptTypeData.templateList.forEach((v,i)=>{
            let str = this.searchName
            let reg = new RegExp(str,'g')
            if(reg.test(v.name)){
              data2.push(v)
            }
          })
          this.templateList = data2
        }else{
          this.notRelatedList = this.clinicDeptTypeData.notRelatedList
          this.templateList = this.clinicDeptTypeData.templateList 
        }

      },
      // 关闭弹出层
      handleClosePopup(){
        },
      // 关闭弹出层
      handleBtnLeft(){
        this.handleReset()
        this.isShowPopup = false
      },
      handleBtnRight(){
        this.handleAddStandardOrTmpDeptByParam()
        this.isShowPopup = false
      },
      handleAddStandardOrTmpDeptByParam(){
        let params = {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          data: {
            comId: this._userInfo.data.comId,
            parentId: this.parentId,
            deptName: this.deptName,
            secondNodeID: localStorage.getItem('secondNodeId'),
            parentDeptCode: this.parentDeptCode,
            parentDeptName: this.parentDeptName,
            deptClassType: '3', // 3 未关联病区(单元)的行政单元 0普通行政单元 1默认分院 2自定义分院
            templateType: this.templateType
          }
        };
        this.$http.addStandardOrTmpDeptByParam(params).then((res) => {
          if (res.code === 0) {
            this.$toast(res.msg);
            this.$emit('successAddStandardOrTmpDept')
            this.handleReset()
          } else {
            this.$toast(res.msg);
          }
        });

      },
      handleReset(){
        this.deptName = ''
        this.parentId = ''
        this.parentDeptCode = ''
        this.parentDeptName = ''
        this.templateType = ''
      },
      handleShowQuickTag(){
        this.isShowQuickTag = !this.isShowQuickTag
      },
      // 选择快速搜索分类标签
      handleConfirmQuickTag(val){
        this.parentDeptName = val.name
        this.parentId = val.id
        this.parentDeptCode = val.parentCode
        this.templateType = val.templateType
        console.log(val,'val');
      },
      conFirmClinicDeptType(val){
        console.log(val,'val');
        this.$emit('conFirmClinicDeptType',val)
      },
      handleBack(){
        this.$emit('closeClinicDeptType')
      },
      handleAdd(){
        this.isShowPopup = true
      }
    },
  }
</script>
<style lang='scss' scoped>
  .clinicDeptType {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #fff;
    .header {
      padding: 15px 15px 15px 5px;
      font-size: 17px;
      color: #000;
      border-bottom:1px solid #eee;
      img {
        width: 22px;
        height: 22px;
      }
      .add{
        padding-left: 15px;
      }
    }
      .search-box {
        position: fixed;
        left: 0;
        top: 80px;
        width: 100%;
        padding: 10px 12px;
        background-color: #fff;
        z-index: 99;
        img {
          position: absolute;
          top: 50%;
          left: 24px;
          transform: translateY(-50%);
          width: 16px;
          height: 16px;
        }
        input {
          height: 30px;
          width: 100%;
          text-indent: 30px;
          opacity: 1;
          border: 1px solid #e5e5e5;
          border-radius: 31px;
          font-size: 14px;
        }
      }
    .container{
      overflow: scroll;
      .item{
        font-size: 16px;
        .item-title{
          height: 44px;
          padding: 0px 15px;
          background: #f2f2f2;
          font-size: 14px;
          color: #999;
        }
        .item-content-box{
          .item-content{
            height: 44px;
            padding: 0px 15px;
            border-bottom: 1px solid #eee;
          }

        }
      }
      .mask{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0, 0.7);
        z-index: 100;
      }
      .dalog-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 85%;
        background-color: #fff;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        border-radius: 10px;
        .dalog-content {
          padding: 24px 12px;
          border-bottom: 1px solid #eee;
          .dalog-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #333333;
            margin-bottom: 10px;
            text-align: center;
          }
          .box{
            .box-item{
              margin-top: 20px;
              input{
                height: 40px;
                width: 100%;
                border: 1px solid #dddddd;
                border-radius: 3px;
                color: #333;
                font-size: 16px;
                text-indent: 10px;
              }
              .ittm-left{
                margin-right: 10px;
                width: 100px;
              }
              .item-right{
                position: relative;
                flex: 1;
                img{
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  right: 10px;
                  width: 20px;
                  height: 20px;
                }
                ul{
                  position: absolute;
                  top: 40px;
                  right: 0px;
                  height: 132px;
                  width: 100%;
                  background-color: #26b4ff;
                  overflow: scroll;
                  z-index: 100;
                  li{
                    height: 40px;
                    padding-left: 10px;
                    color: #fff;
                    border-bottom: 1px solid #eee;
                  }
                }

              }
            }
            
          }
        }
        .btn-box {
          color: #26b4ff;
          .btn {
            flex: 1;
            padding: 12px 0px;
          }
          .btn-gray {
            color: #323233;
            border-right: 1px solid #eee;
          }
        }
      }

    }
  }
</style>